/**
 * The desk's one word for a fact nobody has given.
 *
 * It had five. `DefinitionList` said **"Not set"**, `WordList` said **"None
 * recorded"**, the providers table said **"Not given"**, `PhoneNumber` drew an
 * em-dash, and `RelativeTime` said "Never" — and a provider's record managed
 * to show four of them at once, which reads as four different situations
 * rather than one.
 *
 * Two of the five are kept, because they are **not** the same claim:
 *
 * - **`Never`**, for a moment in time. "First signed in — Never" is a fact
 *   about somebody who has not taken up their invitation, not a gap in what
 *   we hold.
 * - **`—`**, inside a table cell and nowhere else. A column of dashes reads
 *   as "nothing here" at a glance and the heading supplies the meaning; the
 *   same dash on a line of its own, beside an icon, means nothing at all.
 */
export const NOT_RECORDED = 'Not recorded'
